/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IObrienNavViewProps } from './obrien-nav-item';

/**
 *
 * ObrienNavItemView component.
 * @extends {React.PureComponent<IObrienNavViewProps>}
 */
export class ObrienNavItemView extends React.PureComponent<IObrienNavViewProps> {
    public render(): JSX.Element | null {
        const { ObrienNavItem } = this.props;
        return (
            <Module {...ObrienNavItem}>
                {this._renderElement(this.props)}
            </Module>
        );
    }

    private _renderElement(props: IObrienNavViewProps): React.ReactNode | null {
        const { heading, HeadingContainer, Link, linkText, image, text, EditableLink } = props;
        if (heading) {
            return (<Node {...HeadingContainer}>
                {' '}
                {heading}
                {' '}
            </Node>);
        } else if (Link && image) {
            return (
                <Node {...Link}>
                    {linkText}
                    {image}
                </Node>
            );
        } else if (Link) {
            return (EditableLink);
        }
        return (
            <>
                {text}
                {image}
            </>
        );
    }
}

export default ObrienNavItemView;
